import React, { useState, useEffect ,useRef} from 'react';
import { Button, Table, Spin, DatePicker, Popover, Select, Input, Form ,Space} from 'antd';
import { SearchOutlined, RedoOutlined, EyeOutlined ,HomeOutlined} from '@ant-design/icons';
import { Config } from '../../public/js/config';
import Audit from '../../component/audit/audit';//審核彈框
import moment from 'moment';//日期格式化导包
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import Message from '../../component/message/message';

const { Option } = Select;

const ApiLogging = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const tableColumns = {
        requestTime: "request_time",
        returnTime: "return_time",
        userIds: "user_id"
    }

    useEffect(() => {
        var d = new Date();
        d = d.setDate( d.getDate() - 1);
        let newModel = JSON.parse(JSON.stringify(searchModel));
        newModel.startDate = moment(new Date(d), Config.dateFormatALL);
        newModel.endDate = moment(new Date(), Config.dateFormatALL);
        setSearchModel(newModel);
        form.setFieldsValue({
            startDate: moment(new Date(d), Config.dateFormatALL),
            endDate: moment(new Date(), Config.dateFormatALL),
        });
    }, []);

    const submit = () => {
        search(pageSize, 1, "N", true);
    }

    /**查詢用戶信息列表 方法 */
    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        messageShowHandler();
        clearSelect();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        }else{
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        Base.callBackApi("apiLogging/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    /**用戶信息 查詢change方法 */
    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newModel =>{
            return {...newModel,...{[k]:e}};
        });
    }

    const reset = () => {
        var d = new Date();
        d = d.setDate( d.getDate() - 1);
        let newModel = JSON.parse(JSON.stringify(searchModel));
        newModel.startDate = moment(new Date(d), Config.dateFormatALL);
        newModel.endDate = moment(new Date(), Config.dateFormatALL);
        newModel.userIds = "";
        newModel.apiName = "";
        newModel.apiSendingMethod = "";
        newModel.responseCode = "";
        setSearchModel(newModel);
        form.setFieldsValue({
            startDate: moment(new Date(d), Config.dateFormatALL),
            endDate: moment(new Date(), Config.dateFormatALL),
        });
        messageShowHandler();
        clearSelect();
        /* setSearchModel({operationType:""}); */
        setOldSearchModel({});
        setTablesCount(0);
        setPageSize(20);
        setTables([]);
        /* search(pageSize, 1, "N"); */
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        search(pageSize, 1, "Y");
    }

    const checkStartDate = (rule, value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.startDateNoIsNull[Config.backLang]);
        } else {
            if (Base.isNotEmpty(searchModel.endDate) && Base.afterDate(value, searchModel.endDate)) {
                return Promise.reject(trans.startDateMax[Config.backLang]);
            }
            return Promise.resolve();
        }
    }

    const checkEndDate = (rule, value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.endDateNoIsNull[Config.backLang]);
        } else {
            if(Base.isNotEmpty(searchModel.startDate) && Base.afterDate(searchModel.startDate, value)){
                return Promise.reject(trans.endDateMin[Config.backLang])
            }
            return Promise.resolve();
        }
    }
    
    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    /*eslint-disable*/
    const columns = [
        {
            title: trans.user[Config.backLang],
            dataIndex: 'userIds',
            className: 'tableWidth5',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userIds') },
        },
        {
            title: trans.userIp[Config.backLang],
            dataIndex: 'clientIp',
            className: 'tableWidth8',
        },
        {
            title: trans.mode[Config.backLang],
            dataIndex: 'apiSendingMethod',
            className: 'tableWidth6',
        },
        {
            title: trans.apiName[Config.backLang],
            dataIndex: 'apiName',
            className: 'tableWidth10',
        },

        // {
        //     title: trans.head[Config.backLang],
        //     dataIndex: 'requestTttpHeader',
        //     className: 'tableWidth25',
        //     render: (text) => <Popover content={text} title="" trigger="hover">
        //         <div className = "operationLogManageContent">{text}</div>
        //     </Popover>
        // },
        {
            title: trans.status[Config.backLang],
            dataIndex: 'responseCode',
            className: 'tableWidth5',
        },

        {
            title: trans.startTime[Config.backLang],
            dataIndex: 'requestTime',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'requestTime') },
            render: (text) => <div>
                <div>{moment(text).format('YYYY-MM-DD')}</div>
                <div>{moment(text).format('HH:mm:ss')}</div>
            </div>
        },
        {
            title: trans.endTime[Config.backLang],
            dataIndex: 'returnTime',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'returnTime') },
            render: (text) => <div>
                <div>{moment(text).format('YYYY-MM-DD')}</div>
                <div>{moment(text).format('HH:mm:ss')}</div>
             </div>
        },
        {
            title: trans.elapsedTime[Config.backLang],
            dataIndex: 'elapsedTime',
            className: 'tableWidth8',
            render: (text, record) => {
                const duration = new Date(record.returnTime) - new Date(record.requestTime);
                const minutes = duration / (1000.0 ).toFixed(3);
                return <span>{minutes}</span>;
            },
        },
        {
            title: trans.inputParameters[Config.backLang],
            dataIndex: 'requestBody',
            className: 'tableWidth16',
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "operationLogManageContent">{text}</div>
            </Popover>
        },
        {
            title: trans.content[Config.backLang],
            dataIndex: 'responseDesc',
            className: 'tableWidth16',
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "operationLogManageContent">{text}</div>
            </Popover>
        },


    ];
    /*eslint-enable*/

    return (
        <div id="container" className="template">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.sysManage[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 错误信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                {/* 審核彈框 */}
                <Spin size="large" spinning={isLoad} tip={trans.search2[Config.backLang]}>
                    <div className='systabls'>
                        <Form form={form} onFinish={submit}>
                            <div className='sysRow'>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.user[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.user[Config.backLang]} maxLength={100} 
                                            onChange={(e) => searchChange('userIds', e.target.value)}
                                            value={searchModel.userIds || ''}
                                            onKeyDown = {(e) => e.key == "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.apiName[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.apiName[Config.backLang]} maxLength={100} 
                                            onChange={(e) => searchChange('apiName', e.target.value)}
                                            value={searchModel.apiName || ''}
                                            onKeyDown = {(e) => e.key == "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.mode[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Select  placeholder={trans.mode[Config.backLang]} value={searchModel.apiSendingMethod}
                                            className="sysSelect"
                                            onChange={(e) => searchChange('apiSendingMethod', e)}>
                                            <Option value=""></Option>
                                            {context.apiSendingMethodList.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.status[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Select  placeholder={trans.status[Config.backLang]} value={searchModel.responseCode}
                                            className="sysSelect"
                                            onChange={(e) => searchChange('responseCode', e)}>
                                            <Option value=""></Option>
                                            {context.requestStatus.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </div>
                                </div>

                            </div>
                            <div className='sysRow'>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.operationTime[Config.backLang]}</div>
                                    <div className="sysSerchInputTime">
                                        <Form.Item
                                            name="startDate"
                                            rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                { required: true, validator: checkStartDate },
                                            ]}>
                                            <DatePicker placeholder={trans.startTime[Config.backLang]}
                                                className="parts-numberInput datePickerAllWidth"
                                                allowClear={true}
                                                showTime={true}
                                                onChange={(value) => searchChange("startDate", value)}
                                                format={Config.dateFormatALL} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitleTime">{trans.zhi[Config.backLang]}</div>
                                    <div className="sysSerchInputTime">
                                        <Form.Item
                                            name="endDate"
                                            rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                { required: true, validator: checkEndDate },
                                            ]}>
                                            <DatePicker placeholder={trans.endTime[Config.backLang]}
                                                className="parts-numberInput datePickerAllWidth"
                                                allowClear={true}
                                                showTime={true}
                                                onChange={(value) => searchChange("endDate", value)}
                                                format={Config.dateFormatALL} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" htmlType="submit" hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={() => reset()} icon={<RedoOutlined />} >{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                        </Form>
                        <div className="sysLineEight" />
                        <Space size={[5, 5]} wrap className="sysButtonRelative">
                        </Space>
                        <div className="sysTable" id="tableOne">
                            <Table
                                rowKey="logId"
                                columns={columns} //列名
                                scroll={{ x: 1500 }}
                                dataSource={tables} //数据
                                pagination={{  //分页
                                    showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                    onChange: onChange,                        //上页下页或者跳页方法
                                    onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                    total: tablesCount,                  //总共多少条数据
                                    current: current,                    //当前页
                                    pageSize: pageSize,                  //每页显示多少条数据
                                    defaultCurrent: 1,                              //默认当前页为1
                                    size:"small"
                                }}
                                onChange={handleTableChange}
                            />
                        </div>
                    </div>
                </Spin>
            </div>
        </div>
    )
}

export default ApiLogging;